export const userTypes = {
    NONE: 'none',
    STUDENT: 'student',
    TEACHER: 'teacher',
    ADMIN: 'admin',
    SOCIAL_LOBBY_ADMIN: 'social_lobby_admin',
    TRIBE_LEADER: 'tribe leader',
}
